export enum SettingsTab {
    System = 'system',
    Notifications = 'notifications',
}
